import { Link, useLocation } from 'react-router-dom';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showSlogan?: boolean;
  linkToHome?: boolean;
  className?: string;
}

const sizeMap = {
  sm: { width: 'w-[80px] md:w-[100px]', slogan: 'text-[0.38rem] md:text-[0.42rem]' },
  md: { width: 'w-[120px] md:w-[160px]', slogan: 'text-[0.5rem] md:text-[0.58rem]' },
  lg: { width: 'w-[200px] md:w-[280px]', slogan: 'text-[0.6rem] md:text-[0.72rem]' },
  xl: { width: 'w-[240px] md:w-[300px]', slogan: 'text-[1.1rem] md:text-[1.26rem]' },
};

export default function Logo({ size = 'md', showSlogan = true, linkToHome = true, className = '' }: LogoProps) {
  const { width, slogan } = sizeMap[size];
  const location = useLocation();
  const isHome = location.pathname === '/';

  const handleClick = (e: React.MouseEvent) => {
    if (isHome) {
      e.preventDefault();
      window.dispatchEvent(new CustomEvent('tmt-replay-landing'));
    }
  };

  const content = (
    <div className={`flex flex-col items-center ${className}`}>
      <div className={width}>
        <img
          src="https://storage.readdy-site.link/project_files/e63cb4d6-832c-48f6-a8a8-3d5a81b53170/ef2d9ce4-6b5a-4db2-a856-a5b8c19adf39_compressed_ChatGPT_Image_Jul_18__2026__03_28_46_PM-removebg-preview.webp"
          alt="T.M.T Trusted Money Transfer"
          className="w-full h-auto object-contain"
        />
      </div>
      {showSlogan && (
        <p className={`${width} text-foreground-400 ${slogan} tracking-[0.2em] uppercase font-label text-center whitespace-nowrap leading-none mt-0`}>
          Go Digital . Wallet Wise
        </p>
      )}
    </div>
  );

  if (linkToHome) {
    return (
      <Link to="/" onClick={handleClick} className="inline-flex items-center">
        {content}
      </Link>
    );
  }

  return content;
}